const VERSION = "9.0.0";
export {
  VERSION
};
